import Vue from 'vue'
import Vuex from 'vuex'
//import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authState: {
			token: localStorage.getItem('token-app') || '',
			loggedUser: JSON.parse(localStorage.getItem('logged-app')) || '',
			status: 'notlogged',
		},
		settings: {},
		currentPosition: JSON.parse(localStorage.getItem('currentPosition')) || {},
	},
	getters: {
		isAuthenticated: (state) => !!state.authState.token,
		authStatus: (state) => state.authState.status,
		loggedUser: (state) => state.authState.loggedUser,
		settings: (state) => state.settings,
		currentPosition: (state) => state.currentPosition,
	},
	mutations: {
		savePosition(state, position) {
			localStorage.setItem('currentPosition', JSON.stringify(position))
			state.currentPosition = position
		},

		authSuccess(state, { token, loggedUser }) {
			state.authState.status = 'logged'
			state.authState.token = token
			state.authState.loggedUser = loggedUser
			localStorage.setItem('logged-app', JSON.stringify(loggedUser))
		},
		updateLoggedUser(state, loggedUser) {
			state.authState.loggedUser = loggedUser
			localStorage.setItem('logged-app', JSON.stringify(loggedUser))
		},
		logout(state) {
			state.authState.token = ''
			state.authState.loggedUser = {}
			state.authState.status = 'notlogged'
			localStorage.removeItem('logged-app')
		},
		storeSettings(state, settings) {
			state.settings = settings
		},
	},
})
